import Vue from "vue";
import Vuex from "vuex";
import {
	postSection,
	getSection,
	deleteSection,
	putSection,
} from "../../utils/apiFunctions.js";

Vue.use(Vuex);
const state = () => ({
	// SECTION VUE state
	sectionDetails: [],
	sectionAPI: true,
	selectedSection: {},
	isLoadingStatusOne: false,
	questionAdded: false,
});

const getters = {
	// ---------------------------
	// -------- SECTIONS ---------
	// ---------------------------
	getiIsLoadingStatusOne: (state) => state.isLoadingStatusOne,
	getSectionDetails: (state) => state.sectionDetails,
	SectionAPIStatus: (state) => state.sectionAPI,
	getSelectedSection: (state) => state.selectedSection,
	getQuestionAdded: (state) => state.questionAdded,
};

// actions
const actions = {
	// -------------------------
	// ------- SECTION ---------
	// -------------------------
	async saveSectionAPIStatus(state, payload) {
		state.commit("saveSectionAPIStatus", payload);
	},
	async getSection(state, payload) {
		let data = await payload;
		try {
			const response = await getSection(data);
			if (response.status == 200) {
				if (Object.keys(response.data.data).length == 0) {
					let data1 = [];
					state.commit("saveSection", data1);
				} else {
					let len = Object.keys(response.data.data.sectionIDs).length;
					let data1 = [];
					if (len > 0) {
						data1 = response.data.data.sectionIDs;
						data1.map((i) => (i.testID = response.data.data.testID));
						state.commit("saveSection", data1);
					} else {
						let data1 = [];
						state.commit("saveSection", data1);
					}
				}
			}
			return response;
		} catch (error) {
			return error;
		}
	},

	// POST API
	async saveSection(state, payload) {
		let data = await payload;
		data["numberOfQuestions"] = 0;
		data["questions"] = [];
		data["secMarks"] = 0;
		data["typeOfQuestions"] = [];
		try {
			const response = await postSection(data);
			if (response.status == 200) {
				data.sectionID = response.data.data.sectionID;
				state.commit("saveCurrentSection", data);
			}
			return response;
		} catch (error) {
			return error;
		}
	},

	//PUT API
	async editCurrentSection(state, payload) {
		let data = await payload;
		try {
			const response = await putSection(data);
			if (response.status == 200) {
				data.sectionID = response.data.data.sectionID;
				state.commit("editCurrentSection", payload);
			}
			return response;
		} catch (error) {
			return error;
		}
	},

	// DELETE API
	async deleteCurrentSection({ commit }, payload) {
		let data = { sectionID: payload.sectionID, testID: payload.testID };
		try {
			const response = await deleteSection(data);
			if (response.status == 200) {
				commit("deleteCurrentSection", payload);
			}
			return response;
		} catch (error) {
			throw new Error(
				`Delete Selected Section Failed! status: ${error.status}`
			);
		}
	},
};
// mutations
const mutations = {
	isLoadingStatusOne(state, payload) {
		state.isLoadingStatusOne = payload;
	},

	setQuestionAdded(state, payload) {
		state.questionAdded = payload;
	},
	// -----------------------
	// ------- SECTION -------
	// -----------------------
	saveSectionAPIStatus(state, payload) {
		state.sectionAPI = payload;
	},

	saveSelectedSection(state, payload) {
		state.selectedSection = payload;
	},
	saveCurrentSection(state, payload) {
		delete payload.topicID;
		delete payload.portion;
		payload.questions = [];
		payload.typeOfQuestions = [];
		payload.secMarks = 0;
		payload.numberOfQuestions = 0;
		state.sectionDetails.push(payload);
	},
	saveSection(state, payload) {
		state.sectionDetails = payload;
	},
	editCurrentSection(state, payload) {
		for (let i in state.sectionDetails) {
			if (state.sectionDetails[i].sectionID == payload.sectionID) {
				state.sectionDetails[i].testID = payload.testID;
				state.sectionDetails[i].portion = payload.portion;
				state.sectionDetails[i].name = payload.name;
			}
		}
	},
	deleteCurrentSection(state, payload) {
		state.sectionDetails = state.sectionDetails.filter(
			(data) => data.sectionID != payload.sectionID
		);
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
